import * as React from "react";
import { forwardRef } from "react";
const SvgClockNegative = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M50 0A50 50 0 0 0 0 50a50 50 0 0 0 50 50 50 50 0 0 0 50-50A50 50 0 0 0 50 0m-5 10h10v42.113l14.82 8.557 4.33 2.5-5 8.66-4.33-2.5-17.32-10-4.33-2.5L45 53.66z" />
  </svg>
);
const ForwardRef = forwardRef(SvgClockNegative);
export default ForwardRef;
